export default __webpack_public_path__ + "static/media/_close.1e4b9463.svg";